var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSentimentSatisfiedV2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 56,
    viewBox: "0 0 57 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "sentiment_satisfied"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.834 25.667C38.767 25.667 40.334 24.1 40.334 22.167C40.334 20.234 38.767 18.667 36.834 18.667C34.901 18.667 33.334 20.234 33.334 22.167C33.334 24.1 34.901 25.667 36.834 25.667Z",
    fill: "#2EC4B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5007 25.667C22.4336 25.667 24.0007 24.1 24.0007 22.167C24.0007 20.234 22.4336 18.667 20.5007 18.667C18.5677 18.667 17.0007 20.234 17.0007 22.167C17.0007 24.1 18.5677 25.667 20.5007 25.667Z",
    fill: "#2EC4B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.6673 37.3337C25.214 37.3337 22.2507 35.4437 20.6173 32.667H16.7207C18.5873 37.4503 23.2306 40.8337 28.6673 40.8337C34.104 40.8337 38.7473 37.4503 40.614 32.667H36.7173C35.084 35.4437 32.1206 37.3337 28.6673 37.3337ZM28.644 4.66699C15.764 4.66699 5.33398 15.1203 5.33398 28.0003C5.33398 40.8803 15.764 51.3337 28.644 51.3337C41.5473 51.3337 52.0006 40.8803 52.0006 28.0003C52.0006 15.1203 41.5473 4.66699 28.644 4.66699ZM28.6673 46.667C18.354 46.667 10.0007 38.3137 10.0007 28.0003C10.0007 17.687 18.354 9.33366 28.6673 9.33366C38.9807 9.33366 47.334 17.687 47.334 28.0003C47.334 38.3137 38.9807 46.667 28.6673 46.667Z",
    fill: "#2EC4B6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSentimentSatisfiedV2);
export default __webpack_public_path__ + "static/media/sentiment_satisfied_v2.7ac321fc8518fc3c60be008c4982e0fe.svg";
export { ForwardRef as ReactComponent };